var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 1.66667L15.1875 7.5",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 15.833L15.1875 18.333",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 1.66699L6.01562 4.16699",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01562 12.4997L6.01562 18.333",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 14.1663L12.6875 9.16634C12.6875 8.24967 13.1042 7.49967 14.3542 7.49967L16.0208 7.49967C17.2708 7.49967 17.6875 8.24967 17.6875 9.16634L17.6875 14.1663C17.6875 15.083 17.2708 15.833 16.0208 15.833L14.3542 15.833C13.1042 15.833 12.6875 15.083 12.6875 14.1663Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 10.8333L3.51562 5.83333C3.51562 4.91667 3.93229 4.16667 5.18229 4.16667L6.84896 4.16667C8.09896 4.16667 8.51562 4.91667 8.51562 5.83333L8.51562 10.8333C8.51562 11.75 8.09896 12.5 6.84896 12.5L5.18229 12.5C3.93229 12.5 3.51562 11.75 3.51562 10.8333Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigwhite);
export default __webpack_public_path__ + "static/media/configwhite.a48b0f8078b3595780ac61a05901229f.svg";
export { ForwardRef as ReactComponent };